import { removeCartItem, handleQuantityClick, handleQuantityChange } from '../utils/cart-tools';

import '../../styles/cart.scss';
import '../../styles/top-messaging.scss';

const cartEl = document.querySelector('.cart__content');
const textareaEl = cartEl.querySelector('.message-box__textarea');
const wordCountEl = cartEl.querySelector('.message-box__word-count');
const inputs = cartEl.querySelectorAll('.cart-item__qty-controls input');
let textMax;

cartEl.addEventListener('click', (e) => {
  const { currentTarget, target } = e;

  handleQuantityClick({ target });
  removeCartItem({ target });

  // Opens Gift Message Textarea
  if (target.classList.contains('cart__add-gift--trigger')) {
   currentTarget.querySelector('.cart__add-gift').classList.add('open');
  }

  /* Wholesale: Reroutes Place Order Button Click to Login page if not logged in */
  if (
    target.classList.contains('cart__button')
    && (window.theme.isWholesale && !window.theme.customer.isLoggedIn)
  ) {
    e.preventDefault();
    window.location = '/account/login';
  }
});

if (textareaEl) {
  textMax = textareaEl.maxLength;

  textareaEl.addEventListener('keyup', () => {
    const textLength = textareaEl.value.length;

    wordCountEl.innerHTML = `${textMax - textLength} characters remaining`;
  })
}

// Input Change Handler
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.cart__items').addEventListener('change', (event) => {
    const { target } = event;
    handleQuantityChange({ currentTarget: target });
  });
})
